import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import SizeDependedBlock from 'components/SizeDependedBlock';
import { ProgressBar } from './components/ProgressBar';
import { useAudioPlayer } from './hooks/useAudioPlayer';
import { VolumeControlBar } from './components/VolumeControl';
import TimeValues from './components/TimeValues';
import { BackForwardControls } from './components/BackForwardControls';
import PlayButton from './components/PlayButton';

import styles from './styles.module.scss';

export const AudioPlayer = ({ trackSrc, autoPlay }) => {
	const audioPlayerRef = useRef(null);
	const progressBarRef = useRef(null);
	const volumeBarRef = useRef(null);

	const {
		isPlaying,
		currentTime,
		duration,
		calculateTime,
		playPauseToggle,
		changeRange,
		changeVolume,
		dropRange,
		rewind
	} = useAudioPlayer({
		audioPlayerRef,
		progressBarRef,
		volumeBarRef,
		trackSrc
	});

	useEffect(() => {
		if (autoPlay) {
			dropRange();
		}
	}, [trackSrc]);

	return (
		<SizeDependedBlock>
			<div aria-label="mobileContainer" className={styles.audioPlayer}>
				{/* eslint-disable-next-line jsx-a11y/media-has-caption */}
				<audio
					ref={audioPlayerRef}
					src={trackSrc || ''}
					autoPlay={autoPlay}
					preload="metadata"
				/>
				<PlayButton play={playPauseToggle} isPlaying={isPlaying} />
				<TimeValues
					key={duration}
					currentTime={currentTime}
					duration={duration}
					calculateFunction={calculateTime}
				>
					<ProgressBar
						reference={progressBarRef}
						onChangeCallback={changeRange}
					/>
				</TimeValues>
			</div>
			<div aria-label="desktopContainer" className={styles.audioPlayer}>
				{/* eslint-disable-next-line jsx-a11y/media-has-caption */}
				<audio
					ref={audioPlayerRef}
					src={trackSrc || ''}
					autoPlay={autoPlay}
					preload="metadata"
				/>
				<BackForwardControls
					rewindForward={rewind(15)}
					rewindBack={rewind(-15)}
				>
					<PlayButton
						isPlaying={isPlaying}
						play={playPauseToggle}
						rewindForward={rewind(15)}
						rewindBack={rewind(-15)}
					/>
				</BackForwardControls>
				<VolumeControlBar
					volumeBarRef={volumeBarRef}
					changeVolume={changeVolume}
				/>
				<TimeValues
					key={duration}
					currentTime={currentTime}
					duration={duration}
					calculateFunction={calculateTime}
				>
					<ProgressBar
						reference={progressBarRef}
						onChangeCallback={changeRange}
						rewindForward={rewind(15)}
						rewindBack={rewind(-15)}
					/>
				</TimeValues>
			</div>
		</SizeDependedBlock>
	);
};

AudioPlayer.initialProps = {
	autoPlay: false
};

AudioPlayer.propTypes = {
	trackSrc: PropTypes.string.isRequired,
	autoPlay: PropTypes.bool
};
